import React from 'react';
import { Accordion } from '../ui/Accordion';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito saber mucho de matemáticas?',
    a: 'No, si sabés sumar, restar y usar la calculadora del celu, podés usar este manual perfectamente. Está explicado para la calle, no para la facultad.'
  }, {
    q: '¿Sirve para cualquier parte de Argentina?',
    a: 'Sí, el método está diseñado para nuestra realidad económica actual. Te enseña a calcular en base a los precios de tu corralón local y a protegerte de la inflación.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Es un archivo digital (PDF) que te llega al mail apenas hacés el pago. Lo descargás en el momento. No tenés que esperar fletes ni envíos.'
  }, {
    q: '¿Puedo leerlo en un celular con pantalla rota?',
    a: 'Sí, el diseño está pensado especialmente para leerse en celulares. Tiene texto grande, claro y va directo al grano.'
  }];
  return <section className="py-20 px-4 bg-cement-dark" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <h2 className="font-heading font-bold text-4xl md:text-5xl text-charcoal uppercase mb-10 text-center" data-id="element-21">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-22">
          {faqs.map((faq, index) => <Accordion key={index} question={faq.q} answer={faq.a} data-id="element-23" />)}
        </div>
      </div>
    </section>;
}